import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { 
  Home, 
  ArrowBack
} from '@material-ui/icons';

import Header from "../components/Header";
import { Button } from "../components/refectored/Button";

import Logo from "../images/logo-green.svg";
import "./Error404.scss";

const translations = {
  title: {
    en: "Looks like you're lost",
    nl: "Hier lijkt niks te vinden"
  },
  descr: {
    en: "The page you are looking for not available!",
    nl: "De pagina die jij zoekt bestaat niet!"
  },
  backButton: {
    en: "Go Back",
    nl: "Ga Terug"
  },
}

const Error404 = props => {
  const lang = localStorage.getItem('lang')

  const handleGoBack = () => {
    // Check if there's history to go back to
    if (window.history.length > 1) {
      // Try to go back
      window.history.back();
    } else {
      // No history - go to home
      props.history.push('/');
    }
  };

  return (
    <div className="order-page-wrapper error-page-wrapper">
      <Header wv={props.wv} logo={Logo} whiteHeader />
      <main className="main-order-block">
        <section className="order-block">
          <div className="error-block">
            <div className="error-logo">
              <div className="error-number">404</div>
            </div>

            <div className="error-text">
              <h1>{translations.title[lang]}</h1>
              <p>{translations.descr[lang]}</p>
              
              <div className="error-actions">
                <Button
                  color="blue"
                  onClick={handleGoBack}
                  className="action-button back-button"
                >
                  <ArrowBack className="button-icon" />
                  {translations.backButton[lang]}
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

const mapStateToProps = ({ webView }) => ({ wv: webView });

export default compose(
  withRouter,
  connect(mapStateToProps)
)(Error404);
